// File: src/views/Home.js

import React from 'react';
import Hero from '../components/home/Hero';
import ValueProposition from '../components/home/ValueProposition';
import MachineCTA from '../components/home/MachineCTA';

function Home() {
  return (
    <>
      <Hero />
      <ValueProposition />
      <MachineCTA />
    </>
  );
}

export default Home;